document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.promo-video').forEach(video => {

    let hideTimer;
    const HIDE_DELAY_MOUSE = 1000;

    function showControls() {
      clearTimeout(hideTimer);
      if (!video.controls) {
        video.controls = true;
      }
    }

    function hideControls(delay) {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        video.controls = false;
        video.tabIndex = 0;
      }, delay);
    }

    video.addEventListener('pointerenter', showControls);
    video.addEventListener('pointerleave', () => hideControls(HIDE_DELAY_MOUSE));
    video.addEventListener('focus', showControls);
    video.addEventListener('blur',  () => hideControls(HIDE_DELAY_MOUSE));
  });
});
